<!-- 董秘会员资料 -->
<template>
<div class="m-data-input">
    <div class="tips-text">温馨提示：请客观、完整、准确且具体的填写相关信息</div>
    <div class="ncimg-box">
        <div class="label"><span>*</span>您的名片</div>
        <div class="upload-box">
            <label class="choice-img" for="uploadNcimg" v-if="!params.ncimgurl">
                请尽量使用580*320px，文件大小在1M以内的JPG、JPEG、PNG格式
            </label>
            <div class="img-box" v-if="params.ncimgurl">
                <img class="ncimg" :src="params.ncimgurl" />
                <i class="el-icon-error" @click="handleDeleteFile"></i>
            </div>
            <input type="file" id="uploadNcimg" v-if="!params.ncimgurl" style="display: none;" accept="image/png,image/jpg,image/jpeg" @change="handleUploadNcimgChange($event)" />
        </div>
    </div>
    <div class="info-box">
        <div class="info-item">
            <div class="label"><span>*</span>您的姓名</div>
            <van-field v-model="params.name" placeholder="请输入您的姓名，20字以内" maxlength="20" />
        </div>
        <div class="info-item">
            <div class="label"><span>*</span>您的手机</div>
            <van-field v-model="params.mobileno" type="tel" placeholder="请输入您的手机" maxlength="11" />
        </div>
        <div class="info-item">
            <div class="label">您的地区</div>
            <div class="popup-trigger-box" @click="regionPopupShow = true">
                <div class="value" :class="{placeholder: !params.provincecode}">{{ params.provincecode && params.citycode ? (params.province + '/' + params.city) : '请选择' }}</div>
                <i class="el-icon-arrow-right"></i>
            </div>
        </div>
        <div class="info-item">
            <div class="label"><span>*</span>您的公司</div>
            <van-field v-model="params.companyname" placeholder="请输入您的公司" />
        </div>
        <div class="info-item">
            <div class="label"><span>*</span>您的职位</div>
            <van-field v-model="params.dutyname" placeholder="请输入您的职位" />
        </div>
        <div class="info-item">
            <div class="label"><span>*</span>公司类型</div>
            <div class="popup-trigger-box" @click="companytypeShow = true">
                <div class="value" :class="{placeholder: !params.companytype}">{{ params.companytypename ? params.companytypename : '请选择' }}</div>
                <i class="el-icon-arrow-right"></i>
            </div>
        </div>
        <div class="info-item">
            <div class="label"><span>*</span>公司所处阶段</div>
            <div class="popup-trigger-box" @click="companyphaseShow = true">
                <div class="value" :class="{placeholder: !params.companyphase}">{{ params.companyphasename ? params.companyphasename : '请选择' }}</div>
                <i class="el-icon-arrow-right"></i>
            </div>
        </div>
        <div class="info-item">
            <div class="label"><span>*</span>公司计划何时上市</div>
            <div class="popup-trigger-box" @click="companylisttimetypeShow = true">
                <div class="value" :class="{placeholder: !params.companylisttimetype}">{{ params.companylisttimetypename ? params.companylisttimetypename : '请选择' }}</div>
                <i class="el-icon-arrow-right"></i>
            </div>
        </div>
        <div class="info-item">
            <div class="label"><span>*</span>公司计划上市板块</div>
            <div class="popup-trigger-box" @click="companysecuritytypeShow = true">
                <div class="value" :class="{placeholder: !params.companysecuritytype}">{{ params.companysecuritytypename ? params.companysecuritytypename : '请选择' }}</div>
                <i class="el-icon-arrow-right"></i>
            </div>
        </div>
        <div class="info-item">
            <div class="label"><span>*</span>公司年营业额</div>
            <van-field v-model="params.companyincome" placeholder="请输入">
                <div class="unit" slot="button">万元</div>
            </van-field>
        </div>
        <div class="info-item">
            <div class="label"><span>*</span>主营产品/服务</div>
            <van-field v-model="params.companyproduct" placeholder="请描述主营产品/服务" type="textarea" autosize maxlength="500" class="textarea-field" />
        </div>
    </div>
    <van-popup v-model="regionPopupShow" position="bottom">
        <van-picker :columns="regionColumns" @change="handleReginChange" @cancel="handleCancelRegion" @confirm="handleConfirmRegion" value-key="label" show-toolbar title="所在地区" />
    </van-popup>
    <van-popup v-model="companytypeShow" position="bottom">
        <van-picker :columns="companytypeList" @cancel="handleCancelCompanytype" @confirm="handleConfirmCompanytype" value-key="label" show-toolbar title="公司类型" />
    </van-popup>
    <van-popup v-model="companyphaseShow" position="bottom">
        <van-picker :columns="companyphaseList" @cancel="handleCancelCompanyphase" @confirm="handleConfirmCompanyphase" value-key="label" show-toolbar title="公司所处阶段" />
    </van-popup>
    <van-popup v-model="companylisttimetypeShow" position="bottom">
        <van-picker :columns="companylisttimetypeList" @cancel="handleCancelCompanylisttimetype" @confirm="handleConfirmCompanylisttimetype" value-key="label" show-toolbar title="公司计划何时上市" />
    </van-popup>
    <van-popup v-model="companysecuritytypeShow" position="bottom">
        <van-picker :columns="companysecuritytypeList" @cancel="handleCancelCompanysecuritytype" @confirm="handleConfirmCompanysecuritytype" value-key="label" show-toolbar title="公司计划上市板块" />
    </van-popup>
    <div class="btn-box">
        <div class="open-btn" @click="handleSubmitAccountVerify">开通入会</div>
    </div>
</div>
</template>

<script>
import {filetoData64} from '@/common/js/tools.js'
import provinceCityList from '@/common/js/citysFormat.json'
import {getUploadParam, qiniuFormUpload} from '@/api/api.js'
import {submitAccountVerify, uploadDMMemberPayInfo} from '@/api/member.js'
import { mapActions } from 'vuex'
export default {
    data() {
        return {
            params: {
                city: '',
                citycode: '',
                code: '',
                companyincome: '',
                companylisttimetype: '',
                companylisttimetypename: '',
                companyname: '',
                companyphase: '',
                companyphasename: '',
                companyproduct: '',
                companysecuritytype: '',
                companysecuritytypename: '',
                companytype: '',
                companytypename: '',
                dutyname: '',
                mobileno: '',
                name: '',
                ncimgid: '',
                ncimgurl: '',
                province: '',
                provincecode: ''
            },
            uploadFile: null,
            regionPopupShow: false,
            regionColumns: [],
            companytypeShow: false,
            companytypeList: [
                {label: '国有', value: 1},
                {label: '民营', value: 2},
                {label: '合资/外资', value: 3},
                {label: '其它', value: 99}
            ],
            companyphaseShow: false,
            companyphaseList: [
                {label: '前期筹划', value: 1},
                {label: '已签中介', value: 2},
                {label: '已股份制改造', value: 3},
                {label: '已上市/挂牌', value: 4}
            ],
            companylisttimetypeShow: false,
            companylisttimetypeList: [
                {label: '一年内', value: 1},
                {label: '三年内', value: 2},
                {label: '五年内', value: 3},
                {label: '未确定', value: 99}
            ],
            companysecuritytypeShow: false,
            companysecuritytypeList: [
                {label: '沪深主板', value: 1},
                {label: '科创板', value: 2},
                {label: '创业板', value: 3},
                {label: '北交所', value: 4},
                {label: '香港/美国', value: 5},
                {label: '其他', value: 99}
            ],
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        let regionColumns = [{values: []}, {values: []}]
        provinceCityList.forEach(item => {
            regionColumns[0].values.push({
                label: item.label,
                value: item.value
            })
        })
        regionColumns[1].values = JSON.parse(JSON.stringify(provinceCityList[0].children))
        this.regionColumns = regionColumns
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {
        document.title = '董秘俱乐部-会员资料'
    },
    methods: {
        handleUploadNcimgChange(e) {
            if (e.target.files[0]) {
                this.uploadFile = e.target.files[0]
                filetoData64({
                    file: this.uploadFile,
                    success: data => {
                        this.params.ncimgurl = data
                    }
                })
            }
        },
        handleDeleteFile() {
            this.uploadFile = null
            this.params.ncimgurl = ''
        },
        handleReginChange(picker, values) {
            provinceCityList.some(item => {
                if (item.value === values[0].value) {
                    picker.setColumnValues(1, JSON.parse(JSON.stringify(item.children)))
                    return true
                }
            })
        },
        handleCancelRegion() {
            this.regionPopupShow = false
        },
        handleConfirmRegion(e) {
            this.params.province = e[0].label
            this.params.provincecode = e[0].value
            this.params.city = e[1].label
            this.params.citycode = e[1].value
            this.handleCancelRegion()
        },
        handleCancelCompanytype() {
            this.companytypeShow = false
        },
        handleConfirmCompanytype(e) {
            this.params.companytype = e.value
            this.params.companytypename = e.label
            this.handleCancelCompanytype()
        },
        handleCancelCompanyphase() {
            this.companyphaseShow = false
        },
        handleConfirmCompanyphase(e) {
            this.params.companyphase = e.value
            this.params.companyphasename = e.label
            this.handleCancelCompanyphase()
        },
        handleCancelCompanylisttimetype() {
            this.companylisttimetypeShow = false
        },
        handleConfirmCompanylisttimetype(e) {
            this.params.companylisttimetype = e.value
            this.params.companylisttimetypename = e.label
            this.handleCancelCompanylisttimetype()
        },
        handleCancelCompanysecuritytype() {
            this.companysecuritytypeShow = false
        },
        handleConfirmCompanysecuritytype(e) {
            this.params.companysecuritytype = e.value
            this.params.companysecuritytypename = e.label
            this.handleCancelCompanysecuritytype()
        },
        handleSubmitAccountVerify() {
            if (!this.params.ncimgurl) {
                this.$toast.fail('请上传您的名片')
            } else if (!this.params.name) {
                this.$toast.fail('请输入您的姓名')
            } else if (!this.params.mobileno) {
                this.$toast.fail('请输入您的手机号')
            } else if (!/^1[3-9]\d{9}$/.test(this.params.mobileno)) {
                this.$toast.fail('请输入正确的手机号')
            } else if (!this.params.companyname) {
                this.$toast.fail('请输入您的公司')
            } else if (!this.params.dutyname) {
                this.$toast.fail('请输入您的职位')
            } else if (!this.params.companytype) {
                this.$toast.fail('请选择公司类型')
            } else if (!this.params.companyphase) {
                this.$toast.fail('请选择公司所处阶段')
            } else if (!this.params.companylisttimetype) {
                this.$toast.fail('请选择公司计划何时上市')
            } else if (!this.params.companysecuritytype) {
                this.$toast.fail('请选择公司计划上市板块')
            } else if (!this.params.companyincome) {
                this.$toast.fail('请输入公司年营业额')
            } else if (!this.params.companyproduct) {
                this.$toast.fail('请输入公司主营产品/服务')
            } else {
                let params = JSON.parse(JSON.stringify(this.params))
                this.setLoading(true)
                getUploadParam({
                    data: {
                        catecode: 110,
                        datatype: 'IMAGE'
                    },
                    success: res => {
                        params.ncimgurl = res.data.localvurl
                        params.ncimgid = res.data.uploadfilekey
                        let formData = new FormData()
                        formData.append('file', this.uploadFile)
                        formData.append('key', params.ncimgid)
                        formData.append('token', res.data.uploadauth)
                        qiniuFormUpload({
                            url: res.data.uploadurl,
                            data: formData,
                            success: res2 => {
                                submitAccountVerify({
                                    data: params,
                                    success: res3 => {
                                        let payParams = {
                                            ordermoney: 8800,
                                            ordertype: 76,
                                            referusercode: '',
                                            resulturl: window.location.protocol + '//' + window.location.host + this.$router.resolve({name: 'MDmMember'}).href
                                        }
                                        uploadDMMemberPayInfo({
                                            data: payParams,
                                            success: res4 => {
                                                this.setLoading(false)
                                                location.href = res4.data.url
                                            },
                                            error: error => {
                                                this.setLoading(false)
                                                this.$toast.fail(error.msg)
                                            }
                                        })
                                    },
                                    error: error => {
                                        this.setLoading(false)
                                        this.$toast.fail(error.msg)
                                    }
                                })
                            },
                            error: () => {
                                this.setLoading(false)
                                this.$toast.fail('上传失败，请重新上传')
                            }
                        })
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$toast.fail(res.msg)
                    }
                })
            }
        },
        ...mapActions([
            'setLoading'
        ])
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.m-data-input {
    height: 100vh;
    background: #FAF9FF;
    overflow: auto;
    padding: 0.32rem 0.28rem 1.64rem;
    box-sizing: border-box;
    .tips-text {
        font-size: 0.24rem;
        color: #FB7C6F;
        line-height: 0.34rem;
        margin-bottom: 0.32rem;
    }
    .label {
        font-size: 0.28rem;
        color: #333333;
        margin-bottom: 0.34rem;
        span {
            color: #FB7C6F;
            margin-right: 0.1rem;
        }
    }
    .ncimg-box {
        padding: 0.32rem 0.28rem;
        background: #fff;
        border-radius: 0.1rem;
        margin-bottom: 0.32rem;
        .upload-box {
            padding: 0 0.3rem;
            box-sizing: border-box;
            .choice-img {
                width: 100%;
                height: 3.2rem;
                background: #EEEEEE;
                border-radius: 0.1rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 0 0.3rem;
                box-sizing: border-box;
                font-size: 0.24rem;
                color: #999999;
                line-height: 0.34rem;
                text-align: center;
                &::before {
                    width: 0.62rem;
                    height: 0.62rem;
                    background: url('../../../common/images/member/add_icon.png');
                    background-size: 100% 100%;
                    margin-bottom: 0.14rem;
                    content: '';
                }
                .el-icon-plus {
                    font-size: 1rem;
                    color: #999999;
                    margin-bottom: 0.14rem;
                }
            }
            .img-box {
                width: 100%;
                height: 3.2rem;
                position: relative;
                .ncimg {
                    width: 100%;
                    height: 3.2rem;
                    border-radius: 0.1rem;
                }
                .el-icon-error {
                    position: absolute;
                    font-size: 0.34rem;
                    color: #FB7C6F;
                    top: -0.14rem;
                    right: -0.14rem;
                }
            }
        }
    }
    .info-box {
        padding: 0.32rem 0.28rem;
        background: #fff;
        .info-item {
            &:not(:last-of-type) {
                margin-bottom: 0.28rem;
            }
            .label {
                margin-bottom: 0.28rem;
            }
            .van-field {
                padding: 0;
                padding-bottom: 0.2rem;
                border-bottom: 0.01rem solid #E5E5E5;
                .van-field__control {
                    height: 0.45rem;
                    line-height: 0.45rem;
                    font-size: 0.32rem;
                    color: #333333;
                }
                .unit {
                    font-size: 0.32rem;
                    color: #333333;
                }
                &.textarea-field {
                    padding: 0.2rem;
                    border: 0.01rem solid #CCCCCC;
                    border-radius: 0.1rem;
                    .van-field__control {
                        min-height: 3.2rem !important;
                    }
                }
            }
            .popup-trigger-box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-bottom: 0.2rem;
                border-bottom: 0.01rem solid #E5E5E5;
                .value {
                    font-size: 0.32rem;
                    color: #333333;
                    &.placeholder {
                        color: #999999;
                    }
                }
                .el-icon-arrow-right {
                    font-size: 0.34rem;
                    color: #CCCCCC;
                }
            }
        }
        
    }
    .btn-box {
        position: fixed;
        bottom: 0;
        width: 100%;
        padding: 0.32rem 0.28rem;
        height: 1.64rem;
        background: #FAF9FF;
        box-sizing: border-box;
        left: 0;
        .open-btn {
            width: 100%;
            height: 1rem;
            border-radius: 0.1rem;
            background: #1464C8;
            color: #fff;
            text-align: center;
            line-height: 1rem;
            font-size: 0.32rem;
        }
    }
}
</style>